<form [formGroup]="addUserForm" class="contact-form" (ngSubmit)="onSubmit()">

    <ms-input-label [isRequired]="isFieldRequired(addUserForm, 'firstName')" [labelText]="'First Name'" />
    <input type="text" id="firstName" [required]="isFieldRequired(addUserForm, 'firstName')" maxlength="50"
        formControlName="firstName" class="form-control"
        [class.is-invalid]="addUserForm.get('firstName')?.invalid && addUserForm.get('firstName')?.touched"
        [class.is-valid]="addUserForm.get('firstName')?.valid && addUserForm.get('firstName')?.touched && addUserForm.get('firstName')?.value !== ''" />
    @if(addUserForm.get('firstName')?.invalid && addUserForm.get('firstName')?.touched) {
    <div class="error-messages">
        @if(addUserForm.get('firstName')?.errors?.['required']) {
        <p class="text-danger text-start pt-1 mb-0">{{FormValidatorMessages.FirstNameRequired}}</p>
        }
    </div>
    }

    <ms-input-label [isRequired]="isFieldRequired(addUserForm, 'lastName')" [labelText]="'Last Name'" class="mt-3" />
    <input type="text" id="lastName" [required]="isFieldRequired(addUserForm, 'lastName')" maxlength="50" formControlName="lastName"
        class="form-control"
        [class.is-invalid]="addUserForm.get('lastName')?.invalid && addUserForm.get('lastName')?.touched"
        [class.is-valid]="addUserForm.get('lastName')?.valid && addUserForm.get('lastName')?.touched && addUserForm.get('lastName')?.value !== ''" />
    @if(addUserForm.get('lastName')?.invalid && addUserForm.get('lastName')?.touched) {
    <div class="error-messages">
        @if(addUserForm.get('lastName')?.errors?.['required']) {
        <p class="text-danger text-start pt-1">{{FormValidatorMessages.LastNameRequired}}</p>
        }
    </div>
    }
    <ms-input-label [isRequired]="isFieldRequired(addUserForm, 'phone')" [labelText]="'Phone Number'" class="mt-3" />
    <ms-phone-input id="phone-number" formControlName="telephone" />

    <ms-input-label [isRequired]="isFieldRequired(addUserForm, 'email')" [labelText]="'Email Address'" class="mt-3" />
    <ms-email-input formControlName="email" />
    <div class="d-flex justify-content-end mt-5">
        <button type="button" class="btn btn-ms-secondary me-3" (click)="onCancel()">
            Cancel
        </button>
        <button type="submit" class="btn btn-primary">
            @if(isSubmitting) {
            <div class="spinner-border text-light spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
            } @else {
            Submit
            }
        </button>
    </div>
</form>